import Logo from "../../assets/images/VST_Balance_new_logo.png";
import {
  IonGrid,
  IonRow,
  IonCol,
  IonContent,
  IonLabel,
  IonInput,
  IonPage,
  IonImg,
  IonButton,
  IonLoading,
  IonModal,
  useIonViewDidEnter,
} from "@ionic/react";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import ErrorTopToaster from "../../components/ErrorTopToaster";
import {
  ActionType,
  ApplicationLookup,
  BusinessType,
  ResponseCode,
} from "../../models/Enums";
import { LoginAuth } from "../../services/AuthServices";
import React from "react";
import { getMobileUIVersion } from "../../utils/api-interceptor";
import {
  networkConnectionStatus,
  usernameInitialsState,
} from "../../data/atoms";
import { useRecoilState } from "recoil";
import SelectAssesmentTypeModal from "../../components/modals/SelectAssesmentTypeModal";
import { GetAppInformation, GetOSId } from "../../utils/mobile-bridge";
import { MobileInformation } from "../../models/MobileInformation";
import CalibrationErrorModal from "../../components/modals/calibration-error-modal";
import SystemErrorModal from "../../components/modals/system-error-modal";
import IncompleteTestModal from "../../components/modals/incomplete-test-modal";
import AssesmentErrorModal from "../../components/modals/assesment-error-modal";
import AreYouThereModal from "../../components/modals/are-you-there-modal";
import FinishIncompleteTestModal from "../../components/modals/finish-incomplete-test-modal";
import RemovePaperModal from "../../components/modals/remove-paper-modal";
import RaiseHandModal from "../../components/modals/raise-hand-modal";
import WhenReadyRaiseHandModal from "../../components/modals/when-ready-raise-hand-modal";
import ReturnToStartModal from "../../components/modals/return-to-start-modal";
import ParticipantVisibleModal from "../../components/modals/participant-visible-modal";
import ParticipantWithinBoxModal from "../../components/modals/participant-within-box-modal";
import WalkBackModal from "../../components/modals/walk-back-modal";
import { initializePendo } from "../../utils/pendo.js";
import ExitModal from "../../components/modals/exit-modal";
import SelectLocationModal from "../../components/modals/select-location-modal";
import { set } from "date-fns";
interface Props {
  setIsLoggedIn: React.Dispatch<React.SetStateAction<boolean>>;
  updateNetworkStatus: Function;
}

const Login: React.FC<Props> = React.memo(
  ({ setIsLoggedIn, updateNetworkStatus }) => {
    const handleChildClick = (newMessage: any) => {};

    const [shown, setShown] = useState(false);
    const [showLoading, setShowLoading] = useState(false);
    const [isLoginActive, setIsLoginActive] = useState(true);
    const [deviceOS] = useState<any>(GetOSId());
    const [deviceInformation, setDeviceInformation] =
      useState<MobileInformation>({
        oSType: "",
        oSVersion: "",
        deviceModel: "",
        browser: "",
        appVersion: "",
        timeZone: "",
        mDMLocationKey: "",
      });
    const [isReadOnly, setIsReadOnly] = useState(true);
    let [usernameInitials, setUsernameInitials] = useRecoilState(
      usernameInitialsState
    );
    const [assesmentType, setAssesmentType] = useState(false);
    const [CalibrationError, setCalibrationError] = useState(false);
    const [SystemError, setSystemError] = useState(false);
    const [IncompleteTest, setIncompleteTest] = useState(false);
    const [AssesmentError, setAssesmentError] = useState(false);
    const [AreYouThere, setAreYouThere] = useState(false);
    const [FinishIncompleteTest, setFinishIncompleteTest] = useState(false);
    const [showFinishIncompleteTestModal, setShowFinishIncompleteTestModal] =
      useState(false);
    const [RemovePaper, setRemovePaper] = useState(false);
    const [RaiseHand, setRaiseHand] = useState(false);
    const [WhenReadyRaiseHand, setWhenReadyRaiseHand] = useState(false);
    const [ReturnToStart, setReturnToStart] = useState(false);
    const [ParticipantVisible, setParticipantVisible] = useState(false);
    const [ParticipantWithinBox, setParticipantWithinBox] = useState(false);
    const [WalkBack, setWalkBack] = useState(false);
    const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
      networkConnectionStatus
    );
    const [showUserDoesNotExistModal, setShowUserDoesNotExistModal] =
      useState(false);

    //For Locations Modal
    const [locationModal, setLocationModal] = useState(false);
    const [locations, setSelectedLocations] = useState<any>();

    const {
      register,
      setError,
      setValue,
      getValues,
      handleSubmit,
      reset,
      formState: { errors },
    } = useForm({
      defaultValues: {
        text: "",
        password: "",
      },
    });

    let Window = window as any;
    Window["LoginComponentReference"] = {
      component: this,
      SetDeviceInfo: SetDeviceInfo,
    };

    function SetDeviceInfo(deviceInfo: MobileInformation) {
      debugger;
      localStorage.setItem("deviceInfo", JSON.stringify(deviceInfo));
      setDeviceInformation(deviceInfo);
      console.log(deviceInfo);
    }

    useIonViewDidEnter(() => {
      console.log("ionViewDidEnter event fired");
      const info = GetAppInformation();
      if (deviceOS === ApplicationLookup.Android && info != undefined) {
        setDeviceInformation(JSON.parse(info));
      } else if (deviceOS === ApplicationLookup.Desktop && info != undefined) {
        setDeviceInformation(info);
      }
    });

    useEffect(() => {
      console.log(deviceInformation);
    }, [deviceInformation]);
    useEffect(() => {
      getMobileUIVersion();
      if (
        localStorage.getItem("TokenID")! &&
        localStorage.getItem("TokenID")! !== undefined
      ) {
        history.push("/home");
      }
    }, []);

    useEffect(() => {
      debugger;
      console.log("Login Page Mounted");
      // (window as any).webkit.messageHandlers.sendToIoS.postMessage({
      //           methodName: "loadWebContent",
      //           webContentUrl: "https://www.urdupoint.com/",
      //         });
      const storedEmail = JSON.parse(
        localStorage.getItem("loggedInUserName") || "{}"
      );
      if (storedEmail) {
        setValue("text", storedEmail.email); // prefill email
      }
    }, [window.location.href]); // runs every time login page mounts

    localStorage.setItem("patientSearched", "");
    let history = useHistory();

    const handleLocationSelect = (location: any) => {
      console.log("Selected location:", location);
      let username = getValues("text");
      let password = getValues("password");
      setIsLoginActive(true);
      handleRequest(username, password, location?.encryptedServerId);
    };

    function validatePassword(password: any) {
      let pattern =
        /^(?=.*[!@#$%^&*_0-9])(?=.*[A-Z])([^\\s])[a-zA-Z0-9!@#$%^&*._]{7,}$/;
      let Values = password.match(pattern);
      if (Values == null) {
        return false;
      } else {
        return true;
      }
    }

    async function handleRequest(
      Text: string,
      Password: string,
      EncryptedServerId?: string
    ) {
      debugger;
      setShowLoading(true);
      try {
        await LoginAuth({
          UserName: Text,
          Password: Password,
          LoginTime: new Date().toISOString(),
          BusinessType: BusinessType.Cloud,
          MDMLocationKey: deviceInformation.mDMLocationKey,
          EncryptedServerId: EncryptedServerId,
        })
          .then(async function (response) {
            debugger;
            setShowLoading(false);
            setIsLoginActive(false);

            if (response!.data.responseCode === ResponseCode.Success) {
              localStorage.setItem("ExpiresAt", response!.data.expiresAt);
              localStorage.setItem("UserID", response!.data.loggedInUserId);
              localStorage.setItem("BusinessCode", response!.data.businessCode);
              localStorage.setItem(
                "EncryptedServerId",
                response!.data.encryptedServerId
              );
              localStorage.setItem(
                "EncryptedSystemId",
                response!.data.encryptedSystemId
              );
              localStorage.setItem("TokenID", response!.data.token);
              localStorage.setItem("RefreshToken", response!.data.refreshToken);
              localStorage.setItem(
                "TherapistName",
                response!.data.firstName + " " + response!.data.lastName
              );
              localStorage.setItem("isLogin", "true");
              localStorage.setItem("Username", Text);
              localStorage.setItem(
                "loggedInUserName",
                JSON.stringify({ email: Text })
              );

              localStorage.setItem("BusinessType", response!.data.businessType);
              localStorage.setItem("pendoKey", response!.data.pendoKey);
              localStorage.setItem(
                "workstationCode",
                response!.data.workstationCode
              );
              localStorage.setItem("email", response!.data.email);
              localStorage.setItem("firstName", response!.data.firstName);
              localStorage.setItem("lastName", response!.data.lastName);
              localStorage.setItem("businessCode", response!.data.businessCode);
              localStorage.setItem("businessName", response!.data.businessName);
              localStorage.setItem("locationName", response!.data.locationName);
              localStorage.setItem("isRtmEnabled", response!.data.isRTMEnabled);
              localStorage.setItem("isPccEnabled", response!.data.isPccEnabled);

              initializePendo(response!.data);

              if (response!.data.lastName !== null) {
                setUsernameInitials(
                  response!.data.firstName[0] + response!.data.lastName[0]
                );
                setUsernameInitials({
                  userName: Text,
                  initials:
                    response!.data.firstName[0] + response!.data.lastName[0],
                });
                localStorage.setItem(
                  "UsernameInitials",
                  response!.data.firstName[0] + response!.data.lastName[0]
                );
              } else {
                setUsernameInitials(response!.data.firstName.slice(0, 2));
                setUsernameInitials({
                  userName: Text,
                  initials: response!.data.firstName.slice(0, 2),
                });
                localStorage.setItem(
                  "UsernameInitials",
                  response!.data.firstName.slice(0, 2)
                );
              }

              history.replace("/home");
              setIsLoggedIn(true);
              reset();
            } else {
              setIsLoggedIn(false);
              console.log(errors);
              if (response!.data.responseCode === ResponseCode.MultipleUsers) {
                setSelectedLocations(response!.data.locations);
                setLocationModal(true);
              } else if (
                response!.data.responseCode === ResponseCode.UserDoesNotExist
              ) {
                reset();
                setShowUserDoesNotExistModal(true);
              } else if (
                response!.data.responseCode === ResponseCode.UserDisabled
              ) {
                history.replace("/confirmation", {
                  actionType: ActionType.UserDeactivated,
                });
                reset();
              } else if (
                response!.data.responseCode === ResponseCode.PasswordExpired
              ) {
                localStorage.setItem("resetEmail", Text);
                history.replace("/confirmation", {
                  actionType: ActionType.ExpiredPassword,
                });
                reset();
              } else {
                setError("password", {
                  type: "server",
                  message: response!.data.responseMessage,
                });
                setError("text", {
                  type: "server",
                  message: "",
                });
              }
            }
          })
          .catch((error) => {
            setShowLoading(false);
            setIsLoginActive(false);
            history.push("/confirmation", {
              actionType: ActionType.FailureAPIResponse,
            });
          });
      } catch (error) {
        setShowLoading(false);
        setIsLoginActive(false);
        history.push("/confirmation", {
          actionType: ActionType.FailureAPIResponse,
        });
      }
    }

    const checkUserDetail = (e: any, type: string) => {
      let inputUsername = (
        document.getElementById("inputUsername") as HTMLInputElement
      )?.value;
      let inputPassword = (
        document.getElementById("inputPassword") as HTMLInputElement
      )?.value;

      const signInButton = document.getElementById(
        "signIn"
      ) as HTMLButtonElement;

      if (inputUsername?.length !== 0 && inputPassword?.length !== 0) {
        setIsLoginActive(false);
        signInButton?.removeAttribute("disabled");
      } else {
        setIsLoginActive(true);
        signInButton?.setAttribute("disabled", "true");
      }

      setValue("text", inputUsername);
      setValue("password", inputPassword);
    };

    const redirectToAccountRegistration = () => {
      if (!navigator.onLine) {
        setShowNetWorkRecoil({ isShown: true });
        return;
      }
      localStorage.removeItem("TokenID");
      history.replace("/email", {
        actionType: ActionType.NewUser,
      });
    };
    const redirectToForgotPassword = () => {
      if (!navigator.onLine) {
        setShowNetWorkRecoil({ isShown: true });
        return;
      }
      localStorage.removeItem("TokenID");
      history.replace("/email", {
        actionType: ActionType.ForgotPassword,
      });
    };

    return (
      <form
        onSubmit={handleSubmit((data) => {
          handleRequest(data.text, data.password, "");
        })}
        autoComplete="off"
      >
        <IonPage placeholder={undefined}>
          <IonLoading
            cssClass="my-custom-class"
            isOpen={showLoading}
            message={"Please wait..."}
            duration={200}
          />
          <IonModal
            className="assesment-type-modal"
            backdropDismiss={false}
            isOpen={assesmentType}
            placeholder={undefined}
          >
            <SelectAssesmentTypeModal
              setAssesmentType={setAssesmentType}
            ></SelectAssesmentTypeModal>
          </IonModal>
          <IonModal
            className="calibration-error-modal-wrap"
            backdropDismiss={false}
            isOpen={CalibrationError}
            placeholder={undefined}
          >
            <CalibrationErrorModal
              setCalibrationError={setCalibrationError}
            ></CalibrationErrorModal>
          </IonModal>
          <IonModal
            className="system-error-modal-wrap"
            backdropDismiss={false}
            isOpen={SystemError}
            placeholder={undefined}
          >
            <SystemErrorModal
              setSystemError={setSystemError}
            ></SystemErrorModal>
          </IonModal>
          <IonModal
            className="incomplete-test-modal-wrap"
            backdropDismiss={false}
            isOpen={IncompleteTest}
            placeholder={undefined}
          >
            <IncompleteTestModal
              setIncompleteTest={setIncompleteTest}
              onChildClick={handleChildClick}
            ></IncompleteTestModal>
          </IonModal>
          <IonModal
            className="assesment-error-modal-wrap"
            backdropDismiss={false}
            isOpen={AssesmentError}
            placeholder={undefined}
          >
            <AssesmentErrorModal
              setAssesmentError={setAssesmentError}
            ></AssesmentErrorModal>
          </IonModal>
          <IonModal
            className="are-you-there-modal-wrap"
            backdropDismiss={false}
            isOpen={AreYouThere}
            placeholder={undefined}
          >
            <AreYouThereModal
              setAreYouThere={setAreYouThere}
            ></AreYouThereModal>
          </IonModal>
          <IonModal
            className="finish-incomplete-test-modal-wrap"
            backdropDismiss={false}
            isOpen={FinishIncompleteTest}
            placeholder={undefined}
          >
            <FinishIncompleteTestModal
              setFinishIncompleteTest={setFinishIncompleteTest}
              setShowFinishIncompleteTestModal={
                setShowFinishIncompleteTestModal
              }
              onChildClick={handleChildClick}
            ></FinishIncompleteTestModal>
          </IonModal>
          <IonModal
            className="remove-paper-modal-wrap"
            backdropDismiss={false}
            isOpen={RemovePaper}
            placeholder={undefined}
          >
            <RemovePaperModal
              setRemovePaper={setRemovePaper}
            ></RemovePaperModal>
          </IonModal>
          <IonModal
            className="raise-hand-modal-wrap"
            backdropDismiss={false}
            isOpen={RaiseHand}
            placeholder={undefined}
          >
            <RaiseHandModal setRaiseHand={setRaiseHand}></RaiseHandModal>
          </IonModal>
          <IonModal
            className="when-ready-raise-hand-modal-wrap"
            backdropDismiss={false}
            isOpen={WhenReadyRaiseHand}
            placeholder={undefined}
          >
            <WhenReadyRaiseHandModal
              setWhenReadyRaiseHand={setWhenReadyRaiseHand}
            ></WhenReadyRaiseHandModal>
          </IonModal>
          <IonModal
            className="return-to-start-modal-wrap"
            backdropDismiss={false}
            isOpen={ReturnToStart}
            placeholder={undefined}
          >
            <ReturnToStartModal
              setReturnToStart={setReturnToStart}
            ></ReturnToStartModal>
          </IonModal>
          <IonModal
            className="participant-visible-modal-wrap"
            backdropDismiss={false}
            isOpen={ParticipantVisible}
            placeholder={undefined}
          >
            <ParticipantVisibleModal
              setParticipantVisible={setParticipantVisible}
            ></ParticipantVisibleModal>
          </IonModal>
          <IonModal
            className="participant-within-box-modal-wrap"
            backdropDismiss={false}
            isOpen={ParticipantWithinBox}
            placeholder={undefined}
          >
            <ParticipantWithinBoxModal
              setParticipantWithinBox={setParticipantWithinBox}
            ></ParticipantWithinBoxModal>
          </IonModal>
          <IonModal
            className="walk-back-modal-wrap"
            backdropDismiss={false}
            isOpen={WalkBack}
            placeholder={undefined}
          >
            <WalkBackModal setWalkBack={setWalkBack}></WalkBackModal>
          </IonModal>
          {/* Start of UserDoesNotExist Modal */}
          <IonModal
            className="overall-center-modal-main-wrap"
            backdropDismiss={false}
            isOpen={showUserDoesNotExistModal}
            placeholder={undefined}
          >
            <ExitModal
              setShowModal1={setShowUserDoesNotExistModal}
              actionType={ActionType.UserDoesNotExist}
              reset={reset}
              isEdit={false}
            ></ExitModal>
          </IonModal>
          {/* End of UserDoesNotExist Modal */}

          {/* Start of Location Selection Modal */}
          <IonModal
            className="overall-center-modal-main-wrap"
            backdropDismiss={false}
            isOpen={locationModal}
            placeholder={undefined}
          >
            <SelectLocationModal
              isOpen={setLocationModal}
              locations={locations}
              onSelect={handleLocationSelect}
            ></SelectLocationModal>
          </IonModal>
          {/* End of Location Selection Modal */}

          <IonContent
            placeholder={undefined}
            className="bg-image-login slide-in-right"
          >
            <IonGrid className="container top-spacing" placeholder={undefined}>
              <IonRow className="row" placeholder={undefined}>
                <IonCol className="col-sec" placeholder={undefined}>
                  <div className="login-page-inner-wrap">
                    <div className="logos-wrap">
                      <IonImg
                        src={Logo}
                        alt="logo"
                        className="logo"
                        placeholder={undefined}
                      />
                    </div>
                    <div
                      className={`field-wrap ${errors.text && "error-wrap"}`}
                    >
                      <IonLabel className="label" placeholder={undefined}>
                        Email *
                      </IonLabel>
                      <IonInput
                        id="inputUsername"
                        className="input-field"
                        type="text"
                        placeholder="Enter Email"
                        autocomplete="username"
                        readonly={false}
                        {...register("text", {
                          required: true,
                          pattern:
                            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
                        })}
                        onIonChange={(e) => checkUserDetail(e, "username")}
                      />
                      <div className="error-wrap">
                        {errors?.text?.type === "required" && (
                          <p className="error-msg">This field is required</p>
                        )}
                        {errors?.text?.type === "pattern" && (
                          <p className="error-msg">Invalid Email </p>
                        )}
                        {errors.text &&
                          errors.text.type !== "required" &&
                          errors.text.type === "server" &&
                          errors.text.message}
                      </div>
                    </div>
                    <div
                      className={`field-wrap ${
                        errors.password && "error-wrap"
                      }`}
                    >
                      <IonLabel className="label" placeholder={undefined}>
                        Password *
                      </IonLabel>
                      <IonInput
                        id="inputPassword"
                        placeholder="********"
                        className="input-field"
                        autocomplete="off"
                        onIonChange={(e) => checkUserDetail(e, "password")}
                        readonly={false}
                        type={shown ? "text" : "password"}
                        {...register("password", {
                          required: true,
                          pattern:
                            /^(?=.*[!@#$%^&*_0-9])(?=.*[A-Z])([^\\s])[a-zA-Z0-9!@#$%^&*_]{7,}$/,
                        })}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            document.getElementById("signIn")?.click();
                          }
                        }}
                      ></IonInput>
                      <div
                        className="eye-icon"
                        onClick={() => setShown(!shown)}
                      >
                        {shown ? (
                          <svg
                            className="eye-ist-icon"
                            width="24"
                            height="20"
                            viewBox="0 0 22 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11 13C16.5228 13 21 7 21 7C21 7 16.5228 1 11 1C5.47715 1 1 7 1 7C1 7 5.47715 13 11 13Z"
                              stroke="#002E3C"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M11 9C12.1046 9 13 8.10457 13 7C13 5.89543 12.1046 5 11 5C9.89543 5 9 5.89543 9 7C9 8.10457 9.89543 9 11 9Z"
                              stroke="#002E3C"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        ) : (
                          <svg
                            className="eye-sec-icon"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="20"
                            viewBox="0 0 24 20"
                            fill="none"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M2.91789 0.792893C3.30842 0.402369 3.94158 0.402369 4.33211 0.792893L21.3321 17.7929C21.7226 18.1834 21.7226 18.8166 21.3321 19.2071C20.9416 19.5976 20.3084 19.5976 19.9179 19.2071L16.8946 16.1838C15.4729 16.8815 13.8569 17.375 12.1251 17.375C8.84297 17.375 5.96108 15.6045 3.97394 13.9574C2.96619 13.1221 2.15313 12.2891 1.59164 11.6649C1.31031 11.3522 1.09061 11.0902 0.939649 10.9043C0.864133 10.8113 0.80571 10.7371 0.765271 10.6851C0.745048 10.6591 0.729312 10.6385 0.718175 10.6239L0.704926 10.6064L0.700912 10.6011L0.699562 10.5993C0.699562 10.5993 0.698651 10.598 1.50011 10L0.698912 9.4016L0.700005 9.40014L0.702178 9.39725L0.70897 9.38824L0.732245 9.35769C0.752032 9.33188 0.780329 9.29533 0.816852 9.24905C0.889878 9.15652 0.995908 9.02491 1.13267 8.86228C1.40596 8.5373 1.80333 8.08684 2.30665 7.57578C3.12381 6.74606 4.23597 5.74051 5.56436 4.85357L2.91789 2.20711C2.52737 1.81658 2.52737 1.18342 2.91789 0.792893ZM13.5118 12.801L15.3848 14.674C14.3447 15.1083 13.2479 15.375 12.1251 15.375C9.53923 15.375 7.10862 13.958 5.25027 12.4176C4.33528 11.6592 3.59233 10.8984 3.07852 10.3273C2.9723 10.2092 2.87614 10.0995 2.79054 10C3.02745 9.7245 3.34472 9.372 3.73161 8.97917C4.55927 8.13878 5.6866 7.13322 7.01015 6.29936L9.32407 8.61329C9.11681 9.03124 9 9.50238 9 10.0001C9 11.726 10.3991 13.1251 12.125 13.1251C12.6225 13.1251 13.0937 13.0083 13.5118 12.801ZM11.7829 11.0721L11.053 10.3422C11.1633 10.6884 11.4367 10.9618 11.7829 11.0721Z"
                              fill="#002E3C"
                            />
                            <path
                              d="M0.698912 9.4016C0.434196 9.75636 0.433934 10.2433 0.698651 10.598L1.50011 10C0.698651 9.40195 0.698912 9.4016 0.698912 9.4016Z"
                              fill="#002E3C"
                            />
                            <path
                              d="M12.1251 4.625C11.8109 4.625 11.4988 4.64586 11.1895 4.68543C10.6417 4.75551 10.1408 4.36822 10.0707 3.8204C10.0006 3.27258 10.3879 2.77167 10.9357 2.70159C11.3253 2.65175 11.7222 2.625 12.1251 2.625C15.4073 2.625 18.2891 4.39548 20.2763 6.0426C21.284 6.87792 22.0971 7.71095 22.6586 8.3351C22.9399 8.64783 23.1596 8.90982 23.3106 9.09574C23.3861 9.18875 23.4445 9.26286 23.485 9.31491C23.5052 9.34094 23.5209 9.36147 23.5321 9.37611L23.5453 9.39359L23.5493 9.39893L23.5507 9.40074C23.5507 9.40074 23.5516 9.40195 22.7501 10L23.5514 10.5983L23.5496 10.6007L23.5461 10.6054L23.5347 10.6204C23.5251 10.633 23.5117 10.6505 23.4945 10.6728C23.4601 10.7173 23.4104 10.7806 23.3462 10.8602C23.2178 11.0195 23.0311 11.2446 22.7914 11.5159C22.3128 12.0577 21.6191 12.7885 20.7543 13.5492C20.3396 13.9139 19.7077 13.8734 19.343 13.4587C18.9782 13.044 19.0187 12.4121 19.4334 12.0474C20.2217 11.354 20.8562 10.6858 21.2925 10.1918C21.352 10.1244 21.4078 10.0603 21.4597 10C21.3741 9.90046 21.2779 9.79078 21.1717 9.67271C20.6579 9.10155 19.915 8.34083 19 7.5824C17.1416 6.04202 14.711 4.625 12.1251 4.625Z"
                              fill="#002E3C"
                            />
                            <path
                              d="M23.5514 10.5983C23.8161 10.2435 23.8163 9.75671 23.5516 9.40195L22.7501 10C23.5516 10.598 23.5514 10.5983 23.5514 10.5983Z"
                              fill="#002E3C"
                            />
                          </svg>
                        )}
                      </div>
                      <div className="error-wrap">
                        {errors.password &&
                          errors.password.type === "required" && (
                            <p className="error-msg">This field is required</p>
                          )}

                        {errors.password &&
                          errors.password.type !== "required" &&
                          errors.password.type === "server" &&
                          errors.password.message && (
                            <ErrorTopToaster
                              errorString={errors.password.message}
                            />
                          )}
                        {errors.password &&
                          errors.password.type === "pattern" && (
                            <ErrorTopToaster
                              errorString={"Login credentials are incorrect."}
                            />
                          )}
                      </div>
                    </div>

                    <div className="btn-wrap-sec single-btn-wrap">
                      <IonButton
                        id="signIn"
                        className="sign-in-btn"
                        type="submit"
                        disabled={isLoginActive}
                        placeholder={undefined}
                      >
                        Sign In
                      </IonButton>
                    </div>
                    <div className="btn-seperator">
                      <h3>or</h3>
                    </div>
                    <div className="btn-wrap-sec create-new-user">
                      <IonButton
                        className="generic-btn"
                        onClick={() => {
                          reset();
                          setShowLoading(true);
                          redirectToAccountRegistration();
                        }}
                        placeholder={undefined}
                      >
                        Setup Clinician Account
                        {/* <Link to="sigup-email" >Create new user</Link> */}
                      </IonButton>
                    </div>

                    <div className="field-links text-center login-forgot-btn">
                      <span
                        onClick={() => {
                          reset();
                          setShowLoading(true);
                          redirectToForgotPassword();
                        }}
                      >
                        Forgot password?
                      </span>

                      {/* {deviceOS != ApplicationLookup.Desktop && (
                        <p className="version-number">
                          v {deviceInformation.appVersion}
                        </p>
                      )} */}
                    </div>

                    <div className="ion-hide">
                      <IonButton
                        className="generic-btn"
                        placeholder={undefined}
                        onClick={() => {
                          setCalibrationError(true);
                        }}
                      >
                        Calibration Error
                      </IonButton>
                      <IonButton
                        className="generic-btn"
                        placeholder={undefined}
                        onClick={() => {
                          setSystemError(true);
                        }}
                      >
                        System Error
                      </IonButton>
                      <IonButton
                        className="generic-btn"
                        placeholder={undefined}
                        onClick={() => {
                          setIncompleteTest(true);
                        }}
                      >
                        Incomplete Test
                      </IonButton>
                      <IonButton
                        className="generic-btn"
                        placeholder={undefined}
                        onClick={() => {
                          setAssesmentError(true);
                        }}
                      >
                        Assesment Error
                      </IonButton>
                      <IonButton
                        className="generic-btn"
                        placeholder={undefined}
                        onClick={() => {
                          setAreYouThere(true);
                        }}
                      >
                        {" "}
                        Are You here
                      </IonButton>
                      <IonButton
                        className="generic-btn"
                        placeholder={undefined}
                        onClick={() => {
                          setFinishIncompleteTest(true);
                        }}
                      >
                        {" "}
                        Finish Incomplete Test
                      </IonButton>
                      <IonButton
                        className="generic-btn"
                        placeholder={undefined}
                        onClick={() => {
                          setRemovePaper(true);
                        }}
                      >
                        {" "}
                        Remove Paper
                      </IonButton>
                      <IonButton
                        className="generic-btn"
                        placeholder={undefined}
                        onClick={() => {
                          setRaiseHand(true);
                        }}
                      >
                        {" "}
                        Raise Hand
                      </IonButton>
                      <IonButton
                        className="generic-btn"
                        placeholder={undefined}
                        onClick={() => {
                          setWhenReadyRaiseHand(true);
                        }}
                      >
                        {" "}
                        When Ready Raise Hand
                      </IonButton>
                      <IonButton
                        className="generic-btn"
                        placeholder={undefined}
                        onClick={() => {
                          setReturnToStart(true);
                        }}
                      >
                        {" "}
                        Return To Start
                      </IonButton>
                      <IonButton
                        className="generic-btn"
                        placeholder={undefined}
                        onClick={() => {
                          setParticipantVisible(true);
                        }}
                      >
                        {" "}
                        Participant Visible
                      </IonButton>
                      <IonButton
                        className="generic-btn"
                        placeholder={undefined}
                        onClick={() => {
                          setParticipantWithinBox(true);
                        }}
                      >
                        {" "}
                        Participant Within Box
                      </IonButton>
                      <IonButton
                        className="generic-btn"
                        placeholder={undefined}
                        onClick={() => {
                          setWalkBack(true);
                        }}
                      >
                        {" "}
                        Walk Back
                      </IonButton>
                    </div>
                  </div>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonContent>
        </IonPage>
      </form>
    );
  }
);
export default Login;
